import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { typicodeApi } from 'shared/api';

/**
 * Файлы отдаются только с Bearer-токеном, поэтому <img src> напрямую не работает:
 * тянем blob через react-query и превращаем в objectURL.
 * Временный адаптер — когда бэк начнёт отдавать публичный url (MinIO), хук становится не нужен.
 */
export const useFileUrl = (path: string | undefined): string => {
  const { data: blob } = useQuery(['file', path], () => typicodeApi.files.getFileByPath(path as string), {
    enabled: !!path,
    staleTime: Infinity,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!blob?.data) {
      setUrl('');
      return;
    }
    const objectUrl = URL.createObjectURL(blob.data);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob?.data]);

  return url;
};
